import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export default function Label(props) {
  const {
    text,
  } = props;

  return (
    <LabelWrapper>{ text }</LabelWrapper>
  );
}

Label.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
};

const LabelWrapper = styled.label`
  display: block;
  padding: 1rem 0.3rem;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25em;
  background-color: #5bc0de;
  margin: 1.5rem 0;
  margin-bottom: 1.5rem;
`;